export default function removeStatusMsg (status, name)
{
	const new_status = { ...status, fields: { ...(status.fields || { }) } };

	delete new_status.warning;
	delete new_status.error;
	delete new_status.info;

	if (!status.fields || !name || !status.fields[name]) return new_status;

	delete new_status.fields[name];

	return new_status;
}